import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=175eca84&scoped=true&"
import script from "./sku.vue?vue&type=script&lang=js&"
export * from "./sku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175eca84",
  null
  
)

export default component.exports